module.exports = __webpack_public_path__ + "static/img/21080B_3_4_C_20220323_fit.6525120.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/21080B_3_4_C_20220323_fit.png
// module id = MWvR
// module chunks = 0